var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 155.139 155.139",
  "content": "<symbol viewBox=\"0 0 155.139 155.139\" id=\"facebook\">\r\n<g>\r\n\t<path id=\"facebook_f_1_\" d=\"M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184\r\n\t\tc0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452\r\n\t\tv20.341H37.29v27.585h23.814v70.761H89.584z\" />\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n<g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/facebook.svg
// module id = 726
// module chunks = 213534597649335